/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetThreadSuggestedPromptsRequest
 */
export interface GetThreadSuggestedPromptsRequest {
    /**
     * List of prompts to exclude
     * @type {Array<string>}
     * @memberof GetThreadSuggestedPromptsRequest
     */
    exceptions?: Array<string>;
}

/**
 * Check if a given object implements the GetThreadSuggestedPromptsRequest interface.
 */
export function instanceOfGetThreadSuggestedPromptsRequest(value: object): value is GetThreadSuggestedPromptsRequest {
    return true;
}

export function GetThreadSuggestedPromptsRequestFromJSON(json: any): GetThreadSuggestedPromptsRequest {
    return GetThreadSuggestedPromptsRequestFromJSONTyped(json, false);
}

export function GetThreadSuggestedPromptsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetThreadSuggestedPromptsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'exceptions': json['exceptions'] == null ? undefined : json['exceptions'],
    };
}

export function GetThreadSuggestedPromptsRequestToJSON(json: any): GetThreadSuggestedPromptsRequest {
    return GetThreadSuggestedPromptsRequestToJSONTyped(json, false);
}

export function GetThreadSuggestedPromptsRequestToJSONTyped(value?: GetThreadSuggestedPromptsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exceptions': value['exceptions'],
    };
}

